const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const getPaymentHistoryNew = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_PAYMENT_HISTORY_NEW_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getPaymentHistoryNew;